<template>
  <div class="st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form class="form" ref="form" :model="form" :rules="rules" label-position="left" label-width="145px" label-colon>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Product Name" prop="product_id">
              <el-select v-model="form.product_id"
                         clearable
                         filterable
                         style="width:260px">
                <el-option
                  v-for="item in this.productList"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Production Version" prop="version">
              <el-input
                v-model="form.version"
                style="width:260px"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Company Name" prop="company_name">
              <el-select v-model="form.company_name"
                         clearable
                         filterable
                         remote
                         transfer="true"
                         :remote-method="fetchCompany"
                         :loading="isCompanyFetching"
                         @change="onCompanyChange"
                         style="width:260px">
                <el-option
                  v-for="(item, index) in this.companyList"
                  :value="item.value"
                  :key="index"
                  >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Sub Company Name">
              <el-select v-model="form.sub_company_name"
                         clearable
                         style="width:260px">
                <el-option
                  v-for="(item, index) in this.subCompanyList"
                  :value="item"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Request Time" prop="request_time">
              <el-date-picker
                v-model="form.request_time"
                type="date"
                transfer="true"
                value-format="yyyy-MM-dd"
                style="width:260px; position:relative; z-index:0;"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Req. Outline">
              <el-input
                v-model="form.outline"
                style="width:260px"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Req. Detail" style="position:relative; z-index:1;">
              <div id="editor">
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Project Manager" prop="pm_id">
              <el-select v-model="form.pm_id"
                         clearable
                         style="width:260px">
                <el-option
                  v-for="item in this.pmList"
                  :key="item"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Accept">
              <el-select
                v-model="form.accept"
                clearable
                style="width:260px"
              >
                <el-option
                  v-for="item in this.acceptList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Status">
              <el-select
                v-model="form.status"
                clearable
                style="width:260px"
              >
                <el-option
                  v-for="item in this.statusList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Plan Version">
              <el-input
                v-model="form.plan_version"
                style="width:260px"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Actual Version">
              <el-input
                v-model="form.actual_version"
                style="width:260px"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Ticket">
              <el-link type="primary">Link</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="3">
            <el-form-item label="Attachments">
              <el-input
                v-model="form.attachment"
                style="width:360px"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="1">
            <el-button type="primary" @click="submit('form')">
              Submit
            </el-button>
          </el-col>
        </el-row>

      </el-form>
    </el-card>
  </div>
</template>

<script>

import reqApi from '@/api/req.js';
import _ from 'lodash'
import E from 'wangeditor'
import userApi from "@/api/user";
import productApi from "@/api/product";

export default {
  name: "requirementAdd",
  data() {
    return {
      companyList: [],
      subCompanyList: [],
      productList:[],
      pmList:[],
      acceptList:['Accepted','Decline','Partially Accepted'],
      statusList:['To Do','In Progress','Hold','Complete'],
      editor:'',
      editorContent: '',
      loading: '',
      isCompanyFetching: false,
      form: {
          "product_id":'',
          "version":'',
          "company_name":'',
          "sub_company_name":'',
          "request_time":'',
          "outline":'',
          "pm_id":'',
          "accept":'',
          "status":'',
          "plan_version":'',
          "actual_version":'',
          "ticket_id":'',
          "attachment":'',
      },
      rules:{
        product_id: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        version: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        company_name: [{
          required:true, message:'Please Input', trigger:'blur'
        }],
        request_time: [
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        detail:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
        pm_id:[
          {
            required:true, message:'Please Input', trigger:'blur'
          }
        ],
      },
    }
  },
  methods: {
    onCompanyChange(val) {
      Object.assign(this.form, {
        sub_company_name: undefined,
      })
      this.fetchSubCompany(val)
    },
    fetchCompany(query) {
      if (query !== '') {
        this.isCompanyFetching = true
        reqApi.getCompany(query.trim()).then(({data}) => {
          this.isCompanyFetching = false
          this.companyList = (data.data || []).map(item => {
            return {
              value: item,
              label: item,
              key: item,
            }
          })
        })
      } else {
        this.companyList = []
      }
    },
    fetchSubCompany(company_name) {
      reqApi.getSubCompany(company_name).then(res => {
        this.subCompanyList = res.data.data
      })
    },
    createEditor() {
      this.editor = new E('#editor')
      this.initEditor()
      this.editor.create()
    },
    destroyEditor() {
      // this.editor.destroy();
      this.editor = null
    },
    initEditor() {
      (this.editor.customConfig.lang = {
        设置标题: 'title',
        正文: 'p',
        链接文字: 'link text',
        链接: 'link',
        上传图片: 'upload image',
        上传: 'upload',
        创建: 'init',
        // 还可自定添加更多
      }),
        (this.editor.customConfig.uploadImgShowBase64 = true)
    },
    submit() {
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true
            this.editorContent = this.editor.txt.html()
            let payload = Object.assign({}, this.form)
            payload['type'] = 'main'
            payload['product_id'] = this.form.product_id
            payload['version'] = this.form.version
            payload['company_name'] = this.form.company_name
            payload['sub_company_name'] = this.form.sub_company_name
            payload['request_time'] = this.form.request_time
            payload['outline'] = this.form.outline
            payload['detail'] = this.editorContent
            payload['pm_id'] = this.form.pm_id
            payload['accept'] = this.form.accept
            payload['status'] = this.form.status
            payload['plan_version'] = this.form.plan_version
            payload['actual_version'] = this.form.actual_version
            payload['ticket_id'] = this.form.ticket_id
            payload['attachment'] = this.form.attachment
            reqApi.createReq(payload).then()
            this.loading = false
          } else {
            this.$message.error("Please filled with form")
          }
    })
  },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.pmList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.productList.push({value: product.id, label: product.name})
          }
        }
      )

    },

  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        const newCompanyName = _.get(newVal, 'company_name')
        if (newCompanyName && !_.get(oldVal, 'company_name')) {
          this.fetchCompany(newCompanyName)
          this.fetchSubCompany(newCompanyName)
        }
      }
    },
  },
  mounted(){
    this.createEditor()
    this.getSelects()
  },
  beforeDestroy(){
    this.destroyEditor()
  }
}


</script>

<style scoped>
>>>.el-form-item__error {
  display: none;
}
</style>
